const ROOTS = {
  AUTH: '/auth',
  EXPERIENCES: '/benefits/experiences',
  PRODUCTS: '/benefits/products',
  COUPONS: '/benefits/coupons',
  BENEFITS: '/benefits',
  DISCOUNTS: '/benefits/allDiscountsCoupons',
  EVENTS: '/benefits/events',
  POINTS: '/user/pointsHistory',
  PROMOTIONS: '/benefits/promotions',
  COLLECTIBLES: '/benefits/collectibles',
  SEARCH: '/search',
  REGULATION: '/help',
  GAMES: '/games',
};

export const paths = {
  root: '/',
  auth: {
    root: ROOTS.AUTH,
    login: `${ROOTS.AUTH}/login`,
  },

  // PAGES
  benefits: {
    root: `${ROOTS.BENEFITS}/list`,
  },

  navigationMenu: {
    root: '/navigationMenu',
  },

  benefitsList: {
    root: '/benefits/benefitsList',
  },

  missionInstant: {
    root: (id: string) => `/missions/missionInstant/${id}`,
  },

  carPlateResult: {
    root: (id: string) => `/missions/carPlateResult/${id}`,
  },

  missionCarPlate: {
    root: (id: string) => `/missions/missionCarPlate/${id}`,
  },

  offerDetails: {
    root: (id: string) => `/benefits/offerDetails/${id}`,
  },

  simplifiedLp: {
    root: '/help/simplifiedLp',
  },

  myInterestsResult: {
    root: '/myInterests/myInterestsResult',
  },

  myInterestsQuiz: {
    root: '/myInterests/myInterestsQuiz',
  },

  myInterestsInvite: {
    root: '/myInterests/myInterestsInvite',
  },

  regulationDetails: {
    root: (id: string) => `/help/regulationDetails/${id}`,
  },

  regulation: {
    root: `${ROOTS.REGULATION}/regulation`,
    details: (id: string) => `${ROOTS.REGULATION}/regulationDetails/${id}`,
    promotionalAction: (id: string) => `${ROOTS.REGULATION}/promotionalActionDetails/${id}`,
  },

  games: {
    root: ROOTS.GAMES,
    memoryGame: (id: string) => `${ROOTS.GAMES}/memoryGame/${id}`,
    memoryGameDetails: (id: string) => `${ROOTS.GAMES}/memoryGameDetails/${id}`,
    memoryGameResult: (id: string) => `${ROOTS.GAMES}/memoryGameResult/${id}`,
  },

  onboardingEnding: {
    root: '/onboarding/onboardingEnding',
  },

  onboardingSteps: {
    root: '/onboarding/onboardingSteps',
  },

  onboarding: {
    root: '/onboarding/onboarding',
  },

  aboutNotes: {
    root: '/help/aboutNotes',
  },

  aboutPoints: {
    root: '/help/aboutPoints',
  },

  aboutLevels: {
    root: '/help/aboutLevels',
  },

  faq: {
    root: '/help/faq',
  },

  quizResult: {
    root: (id: string) => `/missions/quizResult/${id}`,
  },

  missionQuizQuestions: {
    root: (id: string) => `/missions/missionQuizQuestions/${id}`,
  },

  missionQuiz: {
    root: (id: string) => `/missions/missionQuiz/${id}`,
  },

  missionCheckIn: {
    root: (id: string) => `/missions/missionCheckIn/${id}`,
  },

  missionInvoice: {
    root: (id: string) => `/missions/missionInvoice/${id}`,
  },

  missionCustomScan: {
    root: (id: string) => `/missions/missionCustomScan/${id}`,
  },

  missionCustomScanProgress: {
    root: (id: string) => `/missions/missionCustomScanProgress/${id}`,
  },

  missionCustomScanResult: {
    root: (id: string) => `/missions/missionCustomScanResult/${id}`,
  },

  missionCustomScanV2: {
    root: (id: string) => `/missions/missionCustomScanV2/${id}`,
  },

  missionCustomScanV2Progress: {
    root: (id: string) => `/missions/missionCustomScanV2Progress/${id}`,
  },

  missionCustomScanResultV2: {
    root: (id: string) => `/missions/missionCustomScanResultV2/${id}`,
  },

  missionCustomScanResultV3: {
    root: (id: string) => `/missions/missionCustomScanResultV3/${id}`,
  },

  missionCustomScanV3: {
    root: (id: string) => `/missions/missionCustomScanV3/${id}`,
  },

  missionCustomScanV3Progress: {
    root: (id: string) => `/missions/missionCustomScanV3Progress/${id}`,
  },

  missionsList: {
    root: '/missions/missionsList',
  },

  myLevel: {
    root: '/user/myLevel',
  },

  search: {
    root: ROOTS.SEARCH,
    results: '/search/results',
  },

  promotions: {
    root: ROOTS.PROMOTIONS,
    my: `${ROOTS.PROMOTIONS}/my`,
    details: (id: string) => `${ROOTS.PROMOTIONS}/details/${id}`,
  },

  collectibles: {
    root: ROOTS.COLLECTIBLES,
    collectibleDetails: (id: string) => `${ROOTS.COLLECTIBLES}/details/${id}`,
    rescue: (id: string) => `${ROOTS.COLLECTIBLES}/rescue/${id}`,
  },

  myLevelBenefits: {
    root: '/user/myLevelBenefits',
  },

  myNotesInformation: {
    root: '/user/myNotesInformation',
  },

  pointsHowToEarn: {
    root: '/user/pointsHowToEarn',
  },

  pointsHowToUse: {
    root: '/user/pointsHowToUse',
  },

  myNotes: {
    root: '/user/myNotes',
  },

  pointsHistory: {
    root: ROOTS.POINTS,
    pointsDetails: (id: string) => `${ROOTS.POINTS}/details/${id}`,
  },

  points: {
    root: '/user/points',
  },

  events: {
    root: ROOTS.EVENTS,
    my: `${ROOTS.EVENTS}/my`,
    about: (id: string) => `${ROOTS.EVENTS}/about/${id}`,
    schedule: (id: string) => `${ROOTS.EVENTS}/schedule/${id}`,
    scheduled: (id: string, scheduleId: string) => `${ROOTS.EVENTS}/scheduled/${id}/${scheduleId}`,
  },

  myProfile: {
    root: '/user/myProfile',
  },

  deleteAccount: {
    root: '/user/deleteAccount',
  },

  registrationData: {
    root: '/user/registrationData',
  },

  homolMotor: {
    root: '/test/homolMotor',
  },

  myExchanges: {
    root: '/user/myExchanges',
  },

  products: {
    root: `${ROOTS.PRODUCTS}`,
    details: (id: string) => `${ROOTS.PRODUCTS}/details/${id}`,
    rescue: (id: string, redemptionId: string) => `${ROOTS.PRODUCTS}/rescue/${id}/${redemptionId}`,
  },

  coupons: {
    root: ROOTS.COUPONS,
    benefits: (type: string) => `${ROOTS.BENEFITS}/${type}`,
    discounts: ROOTS.DISCOUNTS,
    couponDetails: (id: string) => `${ROOTS.COUPONS}/details/${id}`,
    couponRescue: (id: string) => `${ROOTS.COUPONS}/couponRescue/${id}`,
    benefitsDetails: (id: string) => `${ROOTS.COUPONS}/benefitsDetails/${id}`,
    benefitsRescue: (id: string) => `${ROOTS.COUPONS}/benefitsRescue/${id}`,
  },

  experiences: {
    root: ROOTS.EXPERIENCES,
    details: (id: string) => `${ROOTS.EXPERIENCES}/details/${id}`,
    rescue: (id: string) => `${ROOTS.EXPERIENCES}/rescue/${id}`,
  },

  home: {
    root: '/home',
  },

  test: {
    root: '/test/test',
  },

  authError: {
    root: '/auth/authError',
  },

  register: {
    root: '/auth/register',
  },

  example: {
    root: '/example',
  },

  testAuthAndGuard: {
    root: '/testAuthAndGuard',
  },

  testRepository: {
    root: '/testRepository',
  },

  error: {
    notFound: '/404',
    forbidden: '/403',
    serverError: '/500',
  },
};
